import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((cfg) => {
  const legacy = window.localStorage.getItem("jk_admin_token");
  if (legacy) cfg.headers["X-Admin-Token"] = legacy;
  const jwt = window.localStorage.getItem("jk_admin_jwt");
  if (jwt) cfg.headers["Authorization"] = `Bearer ${jwt}`;
  return cfg;
});

export default client;

export const publicApi = {
  config: () => client.get("/config").then((r) => r.data),
  listProperties: (params = {}) => client.get("/properties", { params }).then((r) => r.data),
  getProperty: (id) => client.get(`/properties/${id}`).then((r) => r.data),
  createInquiry: (payload) => client.post("/inquiries", payload).then((r) => r.data),
};

export const adminApi = {
  login: (token) => client.post("/admin/login", { token }).then((r) => r.data),
  createProperty: (data) => client.post("/admin/properties", data).then((r) => r.data),
  updateProperty: (id, data) => client.put(`/admin/properties/${id}`, data).then((r) => r.data),
  deleteProperty: (id) => client.delete(`/admin/properties/${id}`).then((r) => r.data),
  listInquiries: () => client.get("/admin/inquiries").then((r) => r.data),
  markInquiry: (id, read) => client.patch(`/admin/inquiries/${id}`, null, { params: { read } }).then((r) => r.data),
  deleteInquiry: (id) => client.delete(`/admin/inquiries/${id}`).then((r) => r.data),
};
